/**
 * El estado de borrado del libro, como filtro de PRIMERA CLASE (#2216).
 *
 * Antes sólo existía la casilla «Mostrar eliminados» (`includeDeleted`), que
 * AMPLIABA el conjunto: vivas → vivas + eliminadas. Nunca podía acotar, así que
 * las 10.845 filas de la papelera sólo eran alcanzables recorriendo las 44.840
 * de la lista completa.
 *
 * Lo modelamos como UN atributo con TRES presentaciones excluyentes en vez de
 * dos booleanos independientes: dos banderas permiten la combinación
 * contradictoria «ni vivas ni eliminadas», que devuelve una rejilla vacía sin
 * explicar por qué, y obligan a cada consumidor (listado, contador, borrado
 * masivo, exportación) a repetir la misma conjunción — dos lecturas del mismo
 * hecho que acaban divergiendo.
 */

/**
 * Los literales viajan en el querystring: backend y frontend leen ESTE catálogo,
 * así que no pueden separarse.
 */
export const TRANSACTION_DELETION_STATUS_FILTERS = ['active', 'deleted', 'all'] as const

export type TransactionDeletionStatusFilter = (typeof TRANSACTION_DELETION_STATUS_FILTERS)[number]

export function isTransactionDeletionStatusFilter(
  value: unknown,
): value is TransactionDeletionStatusFilter {
  return (
    typeof value === 'string' &&
    (TRANSACTION_DELETION_STATUS_FILTERS as readonly string[]).includes(value)
  )
}

/**
 * ÚNICO punto donde la casilla heredada se traduce al tri-estado.
 *
 * Orden deliberado: el tri-estado gana siempre que sea válido. Un enlace
 * antiguo puede arrastrar `includeDeleted=true` en la URL, y combinarlo con una
 * OR devolvería «todas» justo cuando el usuario ha pedido «Eliminadas» — el
 * filtro volvería a mentir. Un valor fuera del catálogo se ignora (no se
 * confía en texto de la URL) pero NO borra la casilla heredada que sí llegó.
 */
export function resolveTransactionDeletionStatus(input: {
  deletionStatus?: unknown
  includeDeleted?: boolean | undefined
}): TransactionDeletionStatusFilter {
  if (isTransactionDeletionStatusFilter(input.deletionStatus)) {
    return input.deletionStatus
  }
  return input.includeDeleted === true ? 'all' : 'active'
}
